import * as React from "react";
import type { SVGProps } from "react";
const SvgClub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="url(#club_svg__a)"
      fillRule="evenodd"
      d="M15.387 5.952a2.53 2.53 0 0 1 2.226 0l6.6 3.245v9.065c0 1.248-.56 2.371-1.936 3.68-1.3 1.238-3.21 2.528-5.775 4.134-2.525-1.607-4.446-3.061-5.752-4.382-1.443-1.46-1.963-2.584-1.963-3.432V9.197zm11.314 12.31V8.441c0-.463-.266-.887-.688-1.094l-7.288-3.584a5.05 5.05 0 0 0-4.45 0L6.986 7.347c-.422.207-.688.63-.688 1.094v9.821c0 1.81 1.074 3.526 2.667 5.137 1.619 1.638 3.953 3.35 6.87 5.161.405.252.922.252 1.328 0 2.867-1.78 5.217-3.313 6.843-4.859 1.659-1.578 2.694-3.295 2.694-5.439m-11.672 2.34c.033.103.168.172.27.172l2.345.009c.101 0 .204-.068.274-.17a.41.41 0 0 0 .038-.343c-.297-.619-.626-1.34-.787-1.993.438.276.945.45 1.455.451 1.393.005 2.564-1.088 2.583-2.46.012-.892-.556-1.615-.991-2.062-1.708-1.825-2.676-3.063-3.34-4.232a.35.35 0 0 0-.303-.173c-.102 0-.205.068-.274.17-.836 1.473-1.974 2.635-3.214 3.865l-.345.342c-.482.478-.932 1.06-.946 2.055-.02 1.372 1.12 2.474 2.514 2.48a2.6 2.6 0 0 0 1.468-.476c-.144.549-.425 1.234-.776 2.022-.036.137-.037.24.03.343"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="club_svg__a"
        x1={23.049}
        x2={10.473}
        y1={7.744}
        y2={24.223}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAEAB3" />
        <stop offset={1} stopColor="#FCB242" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgClub;
